import global from './global.js';
import autocomplete from './autocomplete';
import calendar from './calendar';

export default {
    global,
    autocomplete,
    calendar
}
